/* src/app/shared/components/delivery-defense-score-summary/delivery-defense-score-summary.component.scss */
.summary-title {
  font-size: 0.70506rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.9375rem;
}
.address {
  font-size: 0.70506rem;
  font-style: normal;
  font-weight: 700;
  line-height: 0.9375rem;
}
.message {
  font-size: 0.70506rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0.87994rem;
}
.linear-gauge-container {
  padding-top: 1rem;
}
:host(.delivery-defense-score-summary) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: auto;
  padding: 0.9rem;
  border: solid 2px #C2E3E2;
  border-radius: 0.11281rem;
}
/*# sourceMappingURL=delivery-defense-score-summary.component.css.map */
